// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { Estimate_MaterialCostPageFragmentDoc } from './MaterialCostPage.generated';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveBidItemEstimateMutationVariables = Types.Exact<{
  input: Types.SaveBidItemEstimateInput;
}>;


export type SaveBidItemEstimateMutation = { __typename?: 'Mutation', saveBidItemEstimate: { __typename?: 'SaveBidItemEstimateResult', bidItemEstimate: { __typename?: 'BidItemEstimate', createdAt: Types.Scalars['DateTime']['input'], costInMills: number, id: string, sourceUrl?: string | null | undefined, createdBy: { __typename?: 'User', id: string, name: string }, markets: Array<{ __typename?: 'Market', id: string, name: string }>, bidItemEstimate: { __typename?: 'BidItem', id: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } } } } };

export type BidEstimateModalOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BidEstimateModalOptionsQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name: string }>, unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', id: string, name: string }> };


export const SaveBidItemEstimateDocument = gql`
    mutation SaveBidItemEstimate($input: SaveBidItemEstimateInput!) {
  saveBidItemEstimate(input: $input) {
    bidItemEstimate {
      ...Estimate_MaterialCostPage
    }
  }
}
    ${Estimate_MaterialCostPageFragmentDoc}`;
export type SaveBidItemEstimateMutationFn = Apollo.MutationFunction<SaveBidItemEstimateMutation, SaveBidItemEstimateMutationVariables>;

/**
 * __useSaveBidItemEstimateMutation__
 *
 * To run a mutation, you first call `useSaveBidItemEstimateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBidItemEstimateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBidItemEstimateMutation, { data, loading, error }] = useSaveBidItemEstimateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBidItemEstimateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveBidItemEstimateMutation, SaveBidItemEstimateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveBidItemEstimateMutation, SaveBidItemEstimateMutationVariables>(SaveBidItemEstimateDocument, options);
      }
export type SaveBidItemEstimateMutationHookResult = ReturnType<typeof useSaveBidItemEstimateMutation>;
export type SaveBidItemEstimateMutationResult = Apollo.MutationResult<SaveBidItemEstimateMutation>;
export type SaveBidItemEstimateMutationOptions = Apollo.BaseMutationOptions<SaveBidItemEstimateMutation, SaveBidItemEstimateMutationVariables>;
export const BidEstimateModalOptionsDocument = gql`
    query BidEstimateModalOptions {
  markets {
    ...Named
  }
  unitsOfMeasure {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useBidEstimateModalOptionsQuery__
 *
 * To run a query within a React component, call `useBidEstimateModalOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidEstimateModalOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidEstimateModalOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBidEstimateModalOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidEstimateModalOptionsQuery, BidEstimateModalOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidEstimateModalOptionsQuery, BidEstimateModalOptionsQueryVariables>(BidEstimateModalOptionsDocument, options);
      }
export function useBidEstimateModalOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidEstimateModalOptionsQuery, BidEstimateModalOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidEstimateModalOptionsQuery, BidEstimateModalOptionsQueryVariables>(BidEstimateModalOptionsDocument, options);
        }
export function useBidEstimateModalOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidEstimateModalOptionsQuery, BidEstimateModalOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidEstimateModalOptionsQuery, BidEstimateModalOptionsQueryVariables>(BidEstimateModalOptionsDocument, options);
        }
export type BidEstimateModalOptionsQueryHookResult = ReturnType<typeof useBidEstimateModalOptionsQuery>;
export type BidEstimateModalOptionsLazyQueryHookResult = ReturnType<typeof useBidEstimateModalOptionsLazyQuery>;
export type BidEstimateModalOptionsSuspenseQueryHookResult = ReturnType<typeof useBidEstimateModalOptionsSuspenseQuery>;
export type BidEstimateModalOptionsQueryResult = Apollo.QueryResult<BidEstimateModalOptionsQuery, BidEstimateModalOptionsQueryVariables>;